import { type ParamsOf } from '@next-types/routes'
import { useMemo } from 'react'
import { useParams, useSearchParams } from 'next/navigation'
import { searchParamsToObject } from '@/features/shared/utils/queryString'
import { coerceObjectValues } from '@/features/shop/services/Search/utils'

export const useSearchQueryParams = () => {
  const searchParams = useSearchParams()
  return useMemo(() => searchParamsToObject(searchParams || new URLSearchParams()), [searchParams])
}

type ValidDynamicSearchParams = Partial<
  ParamsOf<'/shop/featured-promotions/[promotion_category_id]'>
>
export const useValidSearchParams = () => {
  const searchParams = useSearchQueryParams()
  const { promotion_category_id } = useParams<ValidDynamicSearchParams>() ?? {}

  return useMemo(
    () => coerceObjectValues({ ...searchParams, promotion_category_id }),
    [searchParams, promotion_category_id],
  )
}
